import axios from 'axios'
import * as Config from '@/Config'

export default class BaseApi {
  constructor (useMock = Config.API_USE_MOCK, waitSeconds = 2) {
    this.setUseMock(useMock)
    this.waitMilliSecond = waitSeconds * 1000
  }

  getMock () {
    throw new Error('Not Implemented')
  }

  getApiPath () {
    throw new Error('Not Implemented')
  }

  setUseMock (useMock) {
    this.useMock = useMock
  }

  static getBaseApiPath () {
    return window.vars.api_base_url
  }

  getFullApiPath () {
    return BaseApi.getBaseApiPath() + this.getApiPath()
  }

  get (params, pathParam = '') {
    let path = this.getFullApiPath()
    if (pathParam !== '') {
      path += `/${pathParam}`
    }
    return this.baseGet(path, params)
  }

  post (params, pathParam = '', headers = []) {
    let path = this.getFullApiPath()
    if (pathParam !== '') {
      path += `/${pathParam}`
    }
    return this.basePost(path, params, headers)
  }

  put (params, pathParam = '', headers = {}) {
    let path = this.getFullApiPath()
    if (pathParam !== '') {
      path += `/${pathParam}`
    }
    return this.basePut(path, params, headers)
  }

  baseGet (path, params) {
    if (this.useMock) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(this.getMock())
        }, this.waitMilliSecond)
      })
    }
    return new Promise((resolve, reject) => {
      axios.get(path, { params })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  basePost (path, params, headers) {
    if (this.useMock) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(this.getMock())
        }, this.waitMilliSecond)
      })
    }
    return new Promise((resolve, reject) => {
      axios.post(path, params, headers)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  basePut (path, params, headers) {
    if (this.useMock) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(this.getMock())
        }, this.waitMilliSecond)
      })
    }
    return new Promise((resolve, reject) => {
      axios.put(path, params, headers)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
